// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app ul.default-option-list.colors[data-v-1fc51c5c]{padding:0}#app .color-disc[data-v-1fc51c5c]{cursor:pointer}", ""]);
// Exports
module.exports = exports;
